var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20938 19.75C6.84479 19.75 6.5349 19.6224 6.27969 19.3672C6.02448 19.112 5.89688 18.8021 5.89688 18.4375V5.96875H5V4.65625H9.1125V4H14.8875V4.65625H19V5.96875H18.1031V18.4375C18.1031 18.7875 17.9719 19.0937 17.7094 19.3562C17.4469 19.6187 17.1406 19.75 16.7906 19.75H7.20938ZM16.7906 5.96875H7.20938V18.4375H16.7906V5.96875ZM9.52813 16.5563H10.8406V7.82812H9.52813V16.5563ZM13.1594 16.5563H14.4719V7.82812H13.1594V16.5563ZM7.20938 5.96875V18.4375V5.96875Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d6af2f13317384144b81db34e5336531.svg";
export { ForwardRef as ReactComponent };